<button mat-icon-button [disabled]="disabled" [matMenuTriggerFor]="menu">
  <elm-icon *ngIf="!hasCustomIcon" icon="clock-2" class="elm-size-icon-m elm-color-icon-action-grey"> </elm-icon>
  <ng-content select="elm-icon"></ng-content>
</button>
